import { FC } from 'react'
import gql from 'graphql-tag'
import { Interweave } from 'interweave'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { Note } from 'svgIcons'
import { DashboardColumns_SelfIntroductionInfoFragment } from 'generated/graphql'
import SelfIntroductionDetailModal from '@app.components/modals/SelfIntroduction/SelfIntroductionDetailModal'
import { formatCreatedAt } from '@app.feature/coverletter/coverletter.write/libs/utils'
import useKeywordHighlighter from 'hooks/useKeywordHighlighter'

gql`
  fragment FileItemMobile_SelfIntroduction on SelfIntroduction {
    id
    title
    createdAt
    deletedAt
    activity {
      id
      recruitType
      recruitCloseAt
    }
    ...SelfIntroductionDetailModal_SelfIntroduction
  }
`

type Props = {
  data: DashboardColumns_SelfIntroductionInfoFragment['selfIntroduction']
  keyword?: string
}

const FileItemMobile: FC<Props> = ({ data, keyword }) => {
  const router = useRouter()

  const handleOpenDetailModal = () => {
    router.push(
      {
        query: {
          ...router.query,
          id: data.id,
        },
      },
      undefined,
      { shallow: true },
    )
  }

  const handleCloseDetailModal = () => {
    const query = router.query
    delete query.id

    router.push({ query }, undefined, { shallow: true })
  }

  const title = useKeywordHighlighter({
    text: data.title || '',
    keyword: keyword || '',
  })

  return (
    <StyledWrapper>
      <div className="item-wrapper" onClick={handleOpenDetailModal}>
        <Note className="note-icon" color="#666" />
        <div className="file-info">
          <div className="file-title">
            <Interweave content={title} />
          </div>
          <div className="info-footer">
            <div className="item-date">{formatCreatedAt(data.createdAt)}</div>
          </div>
        </div>
      </div>
      {router.query.id === data.id && (
        <SelfIntroductionDetailModal
          open
          onClose={handleCloseDetailModal}
          data={data}
        />
      )}
    </StyledWrapper>
  )
}

export default FileItemMobile

const StyledWrapper = styled.div`
  padding: 0 20px;
  .item-wrapper {
    display: flex;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #eee;
    .note-icon {
      margin-right: 12px;
      flex-shrink: 0;
    }
    .file-info {
      display: flex;
      flex-direction: column;
      gap: 2px;

      .file-title {
        width: 100%;
        font-size: 16px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;

        .highlight {
          font-weight: bold;
        }
      }
      .info-footer {
        display: flex;
        gap: 8px;
        font-size: 12px;
        .remain-time {
          color: #ef2929;
        }
      }
    }
  }
`
